<template>
    <div>
      <Navbar />
  
      <main>
  
        <!-- ── Hero ── -->
        <section class="page-hero">
          <div class="page-hero-overlay"></div>
          <div class="page-container">
            <div class="page-hero-content">
              <h1 class="page-hero-title">Contact Us</h1>
              <nav class="breadcrumb-nav" aria-label="Breadcrumb">
                <router-link to="/home" class="breadcrumb-link">Home</router-link>
                <span class="breadcrumb-sep">/</span>
                <span class="breadcrumb-current">Contact Us</span>
              </nav>
            </div>
          </div>
        </section>
  
        <!-- ── Contact Section ── -->
        <section class="section-pad section-gray">
          <div class="page-container">
            <div class="contact-grid">
  
              <!-- Form -->
              <div class="contact-form-card">
                <div class="form-head">
                  <span class="section-badge">Send A Message</span>
                  <h2 class="section-title">We'd Love To Hear From You</h2>
                  <p class="section-body">
                    Whether you need support, product guidance or business enquiries,
                    our team is available to respond promptly.
                  </p>
                </div>
  
                <form @submit.prevent="sendEnquiry" class="contact-form">
                  <div class="form-row full">
                    <input v-model="enquiry_name" type="text" placeholder="Full Name" required class="form-control">
                  </div>
  
                  <div class="form-row two">
                    <input v-model="enquiry_email" type="email" placeholder="Email Address" required class="form-control">
                    <input v-model="enquiry_tel" type="text" placeholder="Phone Number" required class="form-control">
                  </div>
  
                  <div class="form-row full">
                    <textarea v-model="enquiry_message" rows="6" placeholder="Your Message" required class="form-control"></textarea>
                  </div>
  
                  <div class="form-action">
                    <button v-if="loading === false" class="btn-primary-lg" type="submit">
                      Get In Touch
                    </button>
  
                    <button v-else class="btn-primary-lg" disabled>
                      <div class="spinner-border spinner-sm" role="status"></div>
                    </button>
                  </div>
                </form>
              </div>
  
              <!-- Contact Info -->
              <div class="contact-info-card">
                <h4 class="info-title">Our Address Info</h4>
                <p class="info-desc">{{ details.address }}</p>
  
                <h4 class="info-title">Email Support</h4>
                <p class="info-desc">
                  <a :href="'mailto:'+details.email">{{ details.email }}</a><br>
                  <a :href="'mailto:'+details.email2">{{ details.email2 }}</a>
                </p>
  
                <h4 class="info-title">Call Us Directly</h4>
                <p class="info-desc">
                  <a :href="'tel:'+details.tel">{{ details.tel }}</a><br>
                  <a :href="'tel:'+details.tel2">{{ details.tel2 }}</a>
                </p>
  
                <div class="contact-cta-box">
                  <h5>Fast response guaranteed</h5>
                  <p>Our customer success team typically replies within a short time.</p>
                </div>
              </div>
  
            </div>
  
            <!-- Map -->
            <div class="map-shell">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2503.4961826301906!2d0.8914615126610029!3d51.13620057161335!2m3!1f0!2f0!3f0!2m3!1i1024!2i768!4f13.1!3m3!1m2!1s0x47dedafdda0a35cb%3A0x364735060905c499!2s89%20Bentley%20Rd%2C%20Willesborough%2C%20Ashford%20TN24%200HR!5e0!3m2!1sen!2suk!4v1773022112733!5m2!1sen!2suk"
                width="600"
                height="450"
                style="border:0;"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </section>
  
        <!-- ── CTA Band ── -->
        <section class="cta-band">
          <div class="page-container cta-band-inner">
            <div>
              <h2 class="cta-title">Need immediate assistance?</h2>
              <p class="cta-sub">
                Reach out to Mapiibs support and let us help you automate smarter business operations.
              </p>
            </div>
            <a href="https://wa.me/+447414491065" target="_blank" class="btn-white-lg">
              Chat On Whatsapp <font-awesome-icon icon="arrow-right" class="ms-2" />
            </a>
          </div>
        </section>
  
      </main>
  
      <Footer />
    </div>
  </template>
  
  <script>
  import Navbar from "../components/Navbar";
  import Footer from "../components/footer";
  import axios from "axios";
  import { useToast } from "vue-toastification";
  
  export default {
    name: "ContactPage",
  
    components: {
      Navbar,
      Footer,
    },
  
    data() {
      const toast = useToast();
  
      return {
        details: {},
        loading: false,
        toast: toast,
        enquiry_name: "",
        enquiry_email: "",
        enquiry_tel: "",
        enquiry_message: "",
      };
    },
  
    mounted() {
      this.scrollTop();
      this.pageData();
    },
  
    methods: {
      scrollTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      },
  
      pageData() {
        axios.get("/admin/fetchProjectSetup").then((response) => {
          this.details = response.data.data;
          this.loading = false;
        });
      },
  
      async sendEnquiry() {
        this.loading = true;
  
        await axios.post("/send-enquiry", {
          name: this.enquiry_name,
          email: this.enquiry_email,
          message: this.enquiry_message,
          phone_number: this.enquiry_tel,
        })
        .then((res) => {
          this.loading = false;
          this.enquiry_name = "";
          this.enquiry_email = "";
          this.enquiry_message = "";
          this.enquiry_tel = "";
          this.toast.success(res.data.message);
        })
        .catch((error) => {
          if (error.response.status === 422 || error.response.status === 400) {
            this.toast.error(error.response.data.message);
          } else if (error.response.status === 500) {
            this.toast.error("An error occured please try again");
          } else if (error.response.status === 404) {
            this.toast.error("the API route does not exist!");
          } else {
            this.toast.error("An error occured please try again");
          }
          this.loading = false;
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .page-container { max-width:1160px; margin:0 auto; padding:0 24px; }
  .section-pad { padding:80px 0; }
  .section-gray { background:#f4f7fb; }
  .ms-2 { margin-left:8px; }
  
  .section-badge { display:inline-block; background:rgba(0,74,173,.1); color:#004AAD; border:1px solid rgba(0,74,173,.2); border-radius:20px; padding:4px 14px; font-size:12px; font-weight:700; text-transform:uppercase; letter-spacing:.08em; margin-bottom:14px; }
  .section-title { font-size:clamp(24px,3.5vw,34px); font-weight:700; color:#1a2b45; margin:0 0 14px; line-height:1.3; }
  .section-body { font-size:15px; color:#6b7a99; line-height:1.7; margin:0; }
  
  .page-hero {
    position: relative;
    background: linear-gradient(135deg, #051B35 0%, #004AAD 100%);
    padding: 100px 0 64px;
    overflow: hidden;
  }
  .page-hero::before {
    content:'';
    position:absolute;
    inset:0;
    background:url('/static/img/bg-1.jpg') center/cover no-repeat;
    opacity:.08;
  }
  .page-hero-overlay {
    position:absolute;
    inset:0;
    background:linear-gradient(135deg, rgba(5,27,53,.92) 0%, rgba(0,74,173,.75) 100%);
  }
  .page-hero-content { position:relative; z-index:1; text-align:center; }
  .page-hero-title { font-size:clamp(32px,6vw,52px); font-weight:800; color:#fff; margin:0 0 18px; }
  
  .breadcrumb-nav { display:inline-flex; align-items:center; gap:8px; font-size:14px; }
  .breadcrumb-link { color:rgba(255,255,255,.7); text-decoration:none; }
  .breadcrumb-link:hover { color:#fff; }
  .breadcrumb-sep { color:rgba(255,255,255,.3); }
  .breadcrumb-current { color:rgba(255,255,255,.55); }
  
  .contact-grid {
    display:grid;
    grid-template-columns:2fr 1fr;
    gap:28px;
    margin-bottom:40px;
  }
  
  .contact-form-card,
  .contact-info-card {
    background:#fff;
    border:1px solid #e4eaf2;
    border-radius:16px;
    padding:34px;
  }
  
  .contact-info-card {
    background:linear-gradient(135deg,#004AAD,#0059d6);
    color:#fff;
  }
  
  .form-row.full { margin-bottom:18px; }
  .form-row.two {
    display:grid;
    grid-template-columns:1fr 1fr;
    gap:18px;
    margin-bottom:18px;
  }
  
  .form-control {
    width:100%;
    border:1px solid #dfe7f2;
    border-radius:10px;
    padding:14px 16px;
    font-size:14px;
    outline:none;
    background:#fff;
  }
  .form-control:focus {
    border-color:#004AAD;
  }
  
  .form-action {
    margin-top:10px;
  }
  
  .btn-primary-lg {
    border:none;
    background:#004AAD;
    color:#fff;
    padding:13px 26px;
    border-radius:10px;
    font-size:14px;
    font-weight:700;
  }
  .btn-primary-lg:hover {
    background:#003b8e;
  }
  
  .spinner-sm {
    width:18px;
    height:18px;
    border-width:2px;
  }
  
  .info-title {
    font-size:17px;
    font-weight:700;
    margin:0 0 8px;
    color:#fff;
  }
  .info-desc {
    font-size:14px;
    line-height:1.8;
    margin:0 0 28px;
    color:rgba(255,255,255,.8);
  }
  .info-desc a {
    color:rgba(255,255,255,.8);
    text-decoration:none;
  }
  
  .contact-cta-box {
    background:rgba(255,255,255,.08);
    border-radius:12px;
    padding:20px;
    margin-top:10px;
  }
  .contact-cta-box h5 {
    font-size:15px;
    margin:0 0 8px;
  }
  .contact-cta-box p {
    font-size:13px;
    margin:0;
    color:rgba(255,255,255,.7);
  }
  
  .map-shell {
    background:#fff;
    border:1px solid #e4eaf2;
    border-radius:16px;
    padding:12px;
    overflow:hidden;
  }
  .map-shell iframe {
    width:100%;
    border-radius:12px;
  }
  
  .cta-band { background:linear-gradient(135deg,#004AAD,#0059d6); padding:56px 0; }
  .cta-band-inner { display:flex; justify-content:space-between; align-items:center; gap:24px; flex-wrap:wrap; }
  .cta-title { font-size:26px; font-weight:700; color:#fff; margin:0 0 8px; }
  .cta-sub { font-size:15px; color:rgba(255,255,255,.75); margin:0; }
  .btn-white-lg {
    display:inline-flex;
    align-items:center;
    text-decoration:none;
    background:#fff;
    color:#004AAD;
    padding:12px 24px;
    border-radius:10px;
    font-size:14px;
    font-weight:700;
  }
  
  @media (max-width:900px){
    .contact-grid { grid-template-columns:1fr; }
  }
  @media (max-width:768px){
    .section-pad { padding:56px 0; }
    .form-row.two { grid-template-columns:1fr; }
    .page-hero { padding:80px 0 52px; }
  }
  </style>